import { Grid, styled } from '@mui/material';

export const CenterContentGrid = styled(Grid)`
  justify-content: center;
  align-items: center;
`;
